import React from 'react';
import ActivityForm from './ActivityForm';
import RegisterForm from './RegisterForm';

function Forms( form = { name : "",  activity:{} , isEdit : false} ) {

  if(form?.name === 'ActivityForm')
  return (
    <>
      <ActivityForm name={form.name} activity={form?.activity} isEdit = {form?.isEdit} />
    </>
  );
  else if (form.name === 'RegisterForm')
  return   (
      <>
        <RegisterForm name={form.name} activity={form?.activity?.activity} isEdit = {form?.isEdit}/>
      </>
    );
}

export default Forms;